export const parseDiscountToModel = (discount) => ({
  ...discount,
});

export const parseDiscountToObject = (data) => ({
  ...data,
});
